import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Item, ItemState} from "@/modules/item/types";
import {getItems,saveItem, saveItems, updateItem, disableItem, restoreItem, getItemTypes} from "@/services/item";

export const state: ItemState = {
  item: {
    id: "",
    code: "",
    id_item_type: "",
    item_type: "",
    name: "",
    standard_price: "",
    MX: "",
    NALADI: "",
    NALADISA: "",
    unit: ""
  }
}

const actions: ActionTree<ItemState, RootState> = {
  async GET_ITEM(_, id) {
    console.log(id);
  },
  async GET_ITEMS(_, payload) {
    return await getItems(payload);
  },
  async GET_ITEM_TYPES() {
    return await getItemTypes();
  },
  async UPDATE_ITEM(_, item) {
    return await updateItem(item)
  },
  async SAVE_ITEM(_, item) {
    await saveItem(item);
  },
  async SAVE_ITEMS(_, items) {
    await saveItems(items);
  },
  async DISABLE_ITEM(_, id) {
    await disableItem(id);
  },
  async RESTORE_ITEM(_, item) {
    await restoreItem(item);
  }
}

const mutations: MutationTree<ItemState> = {
  SET_ITEM(state, item: Item) {
    state.item = item;
  }
}

const getters: GetterTree<ItemState, RootState> = {
  ITEM(state): Item {
    const {item} = state;
    return {...item};
  }
}

export const item: Module<ItemState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
